module.exports = __webpack_public_path__ + "assets/844ce660588cb12324e1afd7462401ca.mp3";